import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BreakpointsEnum } from '@core/models/enums/breakpoints.enum';
import { ScreenSizeEnum } from '@core/models/enums/screen-size.enum';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private currentScreenSizeEnum = new BehaviorSubject<ScreenSizeEnum | null>(null);
  public currentScreenSizeEnum$ = this.currentScreenSizeEnum.asObservable();

  private isTablet = new BehaviorSubject<boolean>(false);
  public isTablet$ = this.isTablet.asObservable();

  private useTabletLayout = new BehaviorSubject<boolean>(false);
  public useTabletLayout$ = this.useTabletLayout.asObservable();

  constructor(private breakpointObserver: BreakpointObserver) {}

  checkBreakpoints(): void {
    this.breakpointObserver
      .observe([BreakpointsEnum.XS, BreakpointsEnum.SM, BreakpointsEnum.MD, BreakpointsEnum.LG, BreakpointsEnum.XL])
      .subscribe(result => {
        if (
          result.breakpoints[BreakpointsEnum.XS] ||
          result.breakpoints[BreakpointsEnum.SM] ||
          result.breakpoints[BreakpointsEnum.MD]
        ) {
          this.useTabletLayout.next(true);
        } else {
          this.useTabletLayout.next(false);
        }
        if (
          result.breakpoints[BreakpointsEnum.XS] ||
          result.breakpoints[BreakpointsEnum.SM] ||
          result.breakpoints[BreakpointsEnum.MD] ||
          result.breakpoints[BreakpointsEnum.LG]
        ) {
          this.isTablet.next(true);
        } else {
          this.isTablet.next(false);
        }

        if (result.breakpoints[BreakpointsEnum.XS]) {
          this.currentScreenSizeEnum.next(ScreenSizeEnum.XS);
        } else if (result.breakpoints[BreakpointsEnum.SM]) {
          this.currentScreenSizeEnum.next(ScreenSizeEnum.SM);
        } else if (result.breakpoints[BreakpointsEnum.MD]) {
          this.currentScreenSizeEnum.next(ScreenSizeEnum.MD);
        } else if (result.breakpoints[BreakpointsEnum.LG]) {
          this.currentScreenSizeEnum.next(ScreenSizeEnum.LG);
        } else if (result.breakpoints[BreakpointsEnum.XL]) {
          this.currentScreenSizeEnum.next(ScreenSizeEnum.XL);
        }
      });
  }
}
